import { render, staticRenderFns } from "./UserInfoForm.vue?vue&type=template&id=143ff7ca&scoped=true&"
import script from "./UserInfoForm.vue?vue&type=script&lang=js&"
export * from "./UserInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143ff7ca",
  null
  
)

export default component.exports